/* eslint-disable no-magic-numbers */
export enum WIDGET_SIZE {
  SMALL = 3,
  MEDIUM = 5,
  FULL_SIZE = 10
}
/* eslint-enable no-magic-numbers */
